// Blog posts (SEO content) — multilingual IT/EN/FR.
// body: array of paragraphs. A line starting with "## " is rendered as a subheading.


export const BLOG_POSTS = [
  {
    slug: "cosa-vedere-bellagio-un-giorno",
    date: "2026-06-01",
    cover: "/assets/1s8k3o9a_20231117_160126.jpg",
    category: { it: "Guida", en: "Guide", fr: "Guide" },
    readMin: 6,
    title: {
      it: "Cosa vedere a Bellagio in un giorno: itinerario perfetto",
      en: "What to see in Bellagio in one day: the perfect itinerary",
      fr: "Que voir à Bellagio en une journée : l'itinéraire parfait",
    },
    excerpt: {
      it: "Un itinerario a piedi tra la Salita Serbelloni, le ville storiche e gli scorci sul Lago di Como, con i nostri consigli da local.",
      en: "A walking itinerary through Salita Serbelloni, the historic villas and the views over Lake Como, with our local tips.",
      fr: "Un itinéraire à pied entre la Salita Serbelloni, les villas historiques et les vues sur le lac de Côme, avec nos conseils de locaux.",
    },
    body: {
      it: [
        "Bellagio, la \"Perla del Lago di Como\", regala emozioni a ogni angolo. Anche in un solo giorno è possibile assaporarne l'essenza: ecco l'itinerario che consigliamo ai nostri ospiti.",
        "## Mattina: il borgo e la Salita Serbelloni",
        "Iniziate dal cuore del paese, perdendovi tra le caratteristiche scalinate di ciottoli. La più famosa è la Salita Serbelloni, fiancheggiata da botteghe, enoteche e balconi fioriti: uno degli scorci più fotografati del lago.",
        "## Mezzogiorno: le ville e i giardini",
        "Proseguite verso i Giardini di Villa Melzi d'Eril, capolavoro di botanica affacciato sull'acqua, con il suo viale di platani secolari lungo la riva. Poco distante, Villa Serbelloni domina il promontorio.",
        "## Pomeriggio: lungolago e battello",
        "Concedetevi una passeggiata sul lungolago e, se avete tempo, un giro in battello verso Varenna e Menaggio: il celebre \"Centro Lago\" si attraversa in pochi minuti e offre panorami indimenticabili.",
        "## Il nostro consiglio",
        "Pernottare a Bellagio permette di vivere il borgo nelle ore più magiche, all'alba e al tramonto, quando i pullman di turisti sono già ripartiti. Dal nostro B&B raggiungete il centro in pochi minuti d'auto o con una piacevole passeggiata.",
      ],
      en: [
        "Bellagio, the \"Pearl of Lake Como\", delights at every corner. Even in a single day you can capture its essence: here is the itinerary we recommend to our guests.",
        "## Morning: the old town and Salita Serbelloni",
        "Start in the heart of the village, getting lost among the characteristic cobbled stairways. The most famous is Salita Serbelloni, lined with boutiques, wine bars and flower-filled balconies — one of the most photographed spots on the lake.",
        "## Midday: villas and gardens",
        "Continue to the Gardens of Villa Melzi d'Eril, a botanical masterpiece overlooking the water, with its avenue of century-old plane trees along the shore. Nearby, Villa Serbelloni dominates the promontory.",
        "## Afternoon: lakefront and ferry",
        "Enjoy a stroll along the lakefront and, if you have time, a ferry ride to Varenna and Menaggio: the famous \"Centre Lake\" triangle is crossed in just a few minutes and offers unforgettable views.",
        "## Our tip",
        "Staying overnight in Bellagio lets you experience the village in its most magical hours, at dawn and sunset, when the tour buses have already left. From our B&B you reach the centre in a few minutes by car or on a pleasant walk.",
      ],
      fr: [
        "Bellagio, la « Perle du Lac de Côme », émerveille à chaque coin de rue. Même en une seule journée, on peut en saisir l'essence : voici l'itinéraire que nous conseillons à nos hôtes.",
        "## Matin : le village et la Salita Serbelloni",
        "Commencez par le cœur du village en vous perdant dans les escaliers de galets typiques. Le plus célèbre est la Salita Serbelloni, bordée de boutiques, bars à vin et balcons fleuris — l'un des endroits les plus photographiés du lac.",
        "## Midi : les villas et les jardins",
        "Continuez vers les Jardins de la Villa Melzi d'Eril, chef-d'œuvre botanique surplombant l'eau, avec son allée de platanes centenaires le long de la rive. Tout près, la Villa Serbelloni domine le promontoire.",
        "## Après-midi : bord du lac et bateau",
        "Offrez-vous une promenade au bord du lac et, si vous avez le temps, une traversée en bateau vers Varenna et Menaggio : le célèbre « Centre du Lac » se traverse en quelques minutes et offre des panoramas inoubliables.",
        "## Notre conseil",
        "Passer la nuit à Bellagio permet de vivre le village aux heures les plus magiques, à l'aube et au coucher du soleil, quand les cars de touristes sont déjà repartis. Depuis notre B&B, le centre est à quelques minutes en voiture ou par une agréable promenade.",
      ],
    },
  },
  {
    slug: "come-arrivare-a-bellagio",
    date: "2026-05-15",
    cover: "/assets/ius2fcv6_battello.avif",
    category: { it: "Consigli di viaggio", en: "Travel tips", fr: "Conseils de voyage" },
    readMin: 5,
    title: {
      it: "Come arrivare a Bellagio: auto, treno e battello",
      en: "How to get to Bellagio: car, train and ferry",
      fr: "Comment se rendre à Bellagio : voiture, train et bateau",
    },
    excerpt: {
      it: "Tutte le opzioni per raggiungere Bellagio dagli aeroporti di Milano, in treno fino a Como o Varenna e in battello sul Lago di Como.",
      en: "All the options to reach Bellagio from Milan's airports, by train to Como or Varenna, and by ferry across Lake Como.",
      fr: "Toutes les options pour rejoindre Bellagio depuis les aéroports de Milan, en train jusqu'à Côme ou Varenna, et en bateau sur le lac.",
    },
    body: {
      it: [
        "Bellagio si trova nel cuore del Lago di Como e raggiungerla fa già parte del viaggio. Ecco le opzioni principali.",
        "## In auto",
        "Dagli aeroporti di Milano Malpensa, Linate e Bergamo si arriva in circa 1h30-2h. La strada lungo il lago è panoramica ma stretta: guidate con calma. Il nostro B&B dispone di parcheggio privato gratuito, un vantaggio prezioso in zona.",
        "## In treno + battello",
        "Una delle vie più suggestive: treno fino a Varenna-Esino (linea Milano-Tirano) e poi battello fino a Bellagio in circa 15-20 minuti. In alternativa, treno fino a Como e poi battello o autobus.",
        "## In battello",
        "La Navigazione Laghi collega Bellagio con Varenna, Menaggio, Como e Lecco. È il modo più scenografico per spostarsi sul lago, anche senza auto.",
        "## Senza auto a Bellagio",
        "È possibile, ma il nostro consiglio è prevedere taxi o autobus per gli spostamenti: vi indichiamo autisti di fiducia e gli orari aggiornati. Trovate tutti i dettagli nella nostra pagina \"Come arrivare\".",
      ],
      en: [
        "Bellagio lies in the heart of Lake Como, and getting there is already part of the journey. Here are the main options.",
        "## By car",
        "From Milan Malpensa, Linate and Bergamo airports it takes about 1h30-2h. The lakeside road is scenic but narrow: drive calmly. Our B&B offers free private parking, a valuable advantage in the area.",
        "## By train + ferry",
        "One of the most scenic routes: train to Varenna-Esino (Milan-Tirano line) and then ferry to Bellagio in about 15-20 minutes. Alternatively, train to Como and then ferry or bus.",
        "## By ferry",
        "Navigazione Laghi connects Bellagio with Varenna, Menaggio, Como and Lecco. It's the most scenic way to move around the lake, even without a car.",
        "## Without a car in Bellagio",
        "It's possible, but we recommend planning taxis or buses for getting around: we'll point you to trusted drivers and up-to-date timetables. You'll find all the details on our \"Getting here\" page.",
      ],
      fr: [
        "Bellagio se trouve au cœur du lac de Côme, et s'y rendre fait déjà partie du voyage. Voici les principales options.",
        "## En voiture",
        "Depuis les aéroports de Milan Malpensa, Linate et Bergame, comptez environ 1h30-2h. La route au bord du lac est panoramique mais étroite : conduisez tranquillement. Notre B&B dispose d'un parking privé gratuit, un atout précieux dans la région.",
        "## En train + bateau",
        "L'un des itinéraires les plus pittoresques : train jusqu'à Varenna-Esino (ligne Milan-Tirano) puis bateau jusqu'à Bellagio en 15-20 minutes environ. Sinon, train jusqu'à Côme puis bateau ou bus.",
        "## En bateau",
        "La Navigazione Laghi relie Bellagio à Varenna, Menaggio, Côme et Lecco. C'est la façon la plus spectaculaire de se déplacer sur le lac, même sans voiture.",
        "## Sans voiture à Bellagio",
        "C'est possible, mais nous conseillons de prévoir taxis ou bus pour les déplacements : nous vous indiquons des chauffeurs de confiance et les horaires à jour. Tous les détails sur notre page « Accès ».",
      ],
    },
  },
  {
    slug: "dove-mangiare-bellagio-piatti-tipici",
    date: "2026-04-20",
    cover: "/assets/a59tbreh_1782029151592.png",
    category: { it: "Gusto", en: "Food", fr: "Gastronomie" },
    readMin: 5,
    title: {
      it: "Dove mangiare a Bellagio: piatti tipici e consigli",
      en: "Where to eat in Bellagio: typical dishes and tips",
      fr: "Où manger à Bellagio : plats typiques et conseils",
    },
    excerpt: {
      it: "Dai pizzoccheri ai missoltini, una guida ai sapori del Lago di Como e ai ristoranti che consigliamo ai nostri ospiti.",
      en: "From pizzoccheri to missoltini, a guide to the flavours of Lake Como and the restaurants we recommend to our guests.",
      fr: "Des pizzoccheri aux missoltini, un guide des saveurs du lac de Côme et des restaurants que nous conseillons à nos hôtes.",
    },
    body: {
      it: [
        "La cucina del Lago di Como unisce tradizione lacustre e sapori di montagna. Ecco cosa assaggiare a Bellagio e dintorni.",
        "## I piatti da non perdere",
        "Tra le specialità: i missoltini (agoni essiccati del lago), il risotto al pesce persico, i pizzoccheri della vicina Valtellina e i formaggi d'alpeggio. Da accompagnare con un calice di vino della zona.",
        "## I nostri ristoranti consigliati",
        "Selezioniamo per voi trattorie autentiche e ristoranti con vista lago. Nella pagina Bellagio trovate la nostra guida completa, con giorni di chiusura e note utili, scaricabile anche in PDF.",
        "## La colazione al B&B",
        "La giornata inizia con la nostra colazione preparata con cura: croissant caldi appena sfornati, uova, caffè e prodotti freschi. Molti ospiti la indicano come uno dei punti di forza del soggiorno.",
        "## Prenotare conviene",
        "Nei periodi di alta stagione i tavoli con vista vanno a ruba: chiedeteci di prenotare per voi, conosciamo i posti giusti per ogni occasione.",
      ],
      en: [
        "Lake Como cuisine blends lakeside tradition with mountain flavours. Here's what to taste in and around Bellagio.",
        "## Dishes not to miss",
        "Among the specialties: missoltini (sun-dried lake shad), perch risotto, pizzoccheri from nearby Valtellina and alpine cheeses. Pair them with a glass of local wine.",
        "## Our recommended restaurants",
        "We select authentic trattorias and restaurants with lake views for you. On the Bellagio page you'll find our complete guide, with closing days and useful notes, also downloadable as a PDF.",
        "## Breakfast at the B&B",
        "The day begins with our carefully prepared breakfast: warm freshly baked croissants, eggs, coffee and fresh products. Many guests rate it as one of the highlights of their stay.",
        "## Booking pays off",
        "In high season, tables with a view fill up fast: ask us to book for you — we know the right spots for every occasion.",
      ],
      fr: [
        "La cuisine du lac de Côme mêle tradition lacustre et saveurs de montagne. Voici quoi goûter à Bellagio et ses environs.",
        "## Les plats à ne pas manquer",
        "Parmi les spécialités : les missoltini (poissons du lac séchés), le risotto à la perche, les pizzoccheri de la Valteline voisine et les fromages d'alpage. À accompagner d'un verre de vin local.",
        "## Nos restaurants conseillés",
        "Nous sélectionnons pour vous des trattorias authentiques et des restaurants avec vue sur le lac. Sur la page Bellagio, vous trouverez notre guide complet, avec jours de fermeture et notes utiles, téléchargeable en PDF.",
        "## Le petit-déjeuner au B&B",
        "La journée commence par notre petit-déjeuner préparé avec soin : croissants chauds tout juste sortis du four, œufs, café et produits frais. De nombreux hôtes le citent comme l'un des points forts du séjour.",
        "## Réserver est utile",
        "En haute saison, les tables avec vue partent vite : demandez-nous de réserver pour vous — nous connaissons les bons endroits pour chaque occasion.",
      ],
    },
  },
];

export function getPosts(lang = "it") {
  return BLOG_POSTS.map((p) => ({
    slug: p.slug,
    date: p.date,
    cover: p.cover,
    readMin: p.readMin,
    category: p.category[lang] || p.category.it,
    title: p.title[lang] || p.title.it,
    excerpt: p.excerpt[lang] || p.excerpt.it,
  }));
}

export function getPost(slug, lang = "it") {
  const p = BLOG_POSTS.find((x) => x.slug === slug);
  if (!p) return null;
  return {
    slug: p.slug,
    date: p.date,
    cover: p.cover,
    readMin: p.readMin,
    category: p.category[lang] || p.category.it,
    title: p.title[lang] || p.title.it,
    excerpt: p.excerpt[lang] || p.excerpt.it,
    body: p.body[lang] || p.body.it,
  };
}
